import { render, staticRenderFns } from "./TableLayout1.vue?vue&type=template&id=db052a5e&"
import script from "./TableLayout1.vue?vue&type=script&lang=js&"
export * from "./TableLayout1.vue?vue&type=script&lang=js&"
import style0 from "./TableLayout1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports